var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { HOUSE_TYPES, OBJECT_GROUP_TYPE, PARCEL_TYPES, PURPOSES_OF_USE, } from '../pages/MainFormPage/formPages/ProjectPage/formModel.types';
import { projectPageModel } from '../pages/MainFormPage/formPages/ProjectPage/formModel';
import { miscErrors } from '../utils/miscErrors';
var projectPageHelpers = projectPageModel.helpers;
var projectPageSelectors = projectPageModel.selectors;
function makeExistingLoansFromProjectFields(data) {
    if (!projectPageHelpers.isExistingLoanPresented(data)) {
        return [];
    }
    return [
        {
            fixedInterestRateUntil: data.fixedInterestRateUntil,
            monthlyRepayment: data.monthlyRepayment,
            residualDebt: data.residualDebt,
        },
    ];
}
function makeFinancingRequirementDTO(data) {
    var baseCost = projectPageSelectors.BASE_COST(data);
    var additionalCost = projectPageSelectors.ADDITIONAL_COST(data);
    switch (data.purposeOfUse) {
        case PURPOSES_OF_USE.CONSTRUCTION:
            return {
                constructionCosts: baseCost,
                parcelPurchasePrice: additionalCost,
            };
        case PURPOSES_OF_USE.PURCHASE_EXISTING_HOME:
            return {
                purchasePrice: baseCost,
                homeModernizationCosts: additionalCost,
            };
        case PURPOSES_OF_USE.MODERNIZATION:
            return {
                modernizationCosts: additionalCost,
            };
        default:
            return {};
    }
}
function makeRealEstateDTOFromProjectFields(data) {
    var realEstateMeta = {};
    if (projectPageHelpers.shouldShowRealEstateData(data)) {
        if (projectPageHelpers.shouldShowKnownPropertyFields(data)) {
            if (Object.values(HOUSE_TYPES).includes(data.objectType)) {
                realEstateMeta.livingSpace = data.areaInSqm;
            }
            else {
                realEstateMeta.areaInSqm = data.areaInSqm;
            }
            if (projectPageHelpers.shouldShowYearOfConstruction(data)) {
                realEstateMeta.yearOfConstruction = data.yearOfConstruction;
            }
        }
        if (projectPageHelpers.shouldShowMarketValue(data)) {
            realEstateMeta.marketValue = data.marketValue;
        }
    }
    return __assign({ typeOfUse: data.typeOfUse, type: data.objectType, postalAddress: __assign(__assign({}, (data.isPostalAddressKnown && data.postalAddress)), { country: 'DE' }), existingLoans: makeExistingLoansFromProjectFields(data) }, realEstateMeta);
}
function makeProjectStructureFromProjectFields(data, mortgageCaseMeta) {
    var caseId = mortgageCaseMeta.caseId, firstHouseholdId = mortgageCaseMeta.firstHouseholdId, secondHouseholdId = mortgageCaseMeta.secondHouseholdId;
    if (caseId === null) {
        throw miscErrors.makeMortgageCaseMetaUnassignedFieldError('caseId');
    }
    var availableEquity = typeof data.availableEquity === 'number' ? data.availableEquity : 0;
    var base = __assign(__assign(__assign({ caseId: caseId }, (firstHouseholdId !== null && {
        householdAssets: {
            householdId: firstHouseholdId,
            assets: [
                {
                    currentValue: availableEquity,
                    maxAvailableValue: availableEquity,
                },
            ],
        },
    })), (secondHouseholdId !== null && {
        secondhouseholdAssets: {
            householdId: secondHouseholdId,
            assets: [],
        },
    })), { project: __assign({ purposeOfUse: data.purposeOfUse, financingRequirement: makeFinancingRequirementDTO(data), loans: [
                {
                    amount: data.loanAmount,
                    timeOfDemand: data.loanTimeOfDemand,
                },
            ], object: makeRealEstateDTOFromProjectFields(data) }, (projectPageHelpers.shouldSetProjectStatus(data) && {
            status: data.projectStatus,
        })) });
    if (data.objectGroupType === OBJECT_GROUP_TYPE.APARTMENTS) {
        delete base.project.object.type;
    }
    if (data.objectGroupType === OBJECT_GROUP_TYPE.PROPERTY) {
        base.project.object.type = PARCEL_TYPES.RESIDENTAL;
    }
    return base;
}
export var projectService = {
    saveFields: function (data, mortgageCaseMeta) {
        return __awaiter(this, void 0, Promise, function () {
            var households;
            return __generator(this, function (_a) {
                households = makeProjectStructureFromProjectFields(data, mortgageCaseMeta);
                return [2 /*return*/, axios.post('/api/project', households)];
            });
        });
    },
};
